import React from 'react';

import { useMediaQuery, useTheme } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

type InputProps = {
  tooltipText: string;
  option: string;
  Image?: React.ReactElement;
  Icon?: React.ReactNode;
  isSelected: boolean;
  isSelectable?: boolean;
  className?: string;
  isTitleOption?: boolean;
};

export const UiDropdownOptionWithTooltip = ({
  tooltipText,
  option,
  Image,
  Icon,
  isSelected,
  isSelectable,
  className,
  isTitleOption,
}: InputProps) => {
  const theme = useTheme();
  const isOnMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div
      className={`navDropdown ${isSelected ? 'navDropdown--selected' : ''} ${
        isTitleOption ? 'navDropdown-firstOption' : ''
      } ${isSelectable ? 'navDropdown-selectOption' : ''} ${
        isOnMobile ? 'navDropdown-mobile' : ''
      } ${className || ''}`}
    >
      {Icon || null}
      {Image || null}
      <div className="navDropdown-nameContainer">
        <Tooltip title={tooltipText} arrow enterDelay={700} enterNextDelay={700}>
          <div className={`navDropdown-name ${isTitleOption ? 'u-color-inherit' : ''}`}>
            {option}
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
